import { submitForm, cleanFormInputs } from '@forms/create_quote.js';
import { popupShow } from '@help/popup.js';

import axios from 'axios';
import Cookies from 'js-cookie';


export function stripeDepositFormHandler() {
  console.log("HANDLER")
  if (window.Stripe) {
    console.log("WINDOW STRIPE")
    // Модалка
    const modal = document.querySelector('.payment-modal');
    const layout = modal.closest('.layout');
    const payDepositBtn = document.querySelector('.pay-deposit-btn');
    const getQuoteBtn = document.querySelector('.get-quote-btn');
    const closeBtn = modal.querySelector('.close');
    const errorMessage = modal.querySelector('.error-message');

    console.log('BTN', payDepositBtn)
    payDepositBtn.addEventListener('click', () => {
      console.log("CLICCCCCCK")
      payDepositBtn.classList.add('disabled');
      getQuoteBtn.classList.add('disabled');
      modal.style.display = 'block';
      const quoteForm = document.querySelector('.create-quote-form');
      submitForm(quoteForm, true)
        .then(quoteId => {
          if (quoteId) {
            const csrfToken = Cookies.get('csrftoken');
            axios.defaults.headers.common['X-CSRFToken'] = csrfToken;
            axios
              .post('/api/v1/quote-pay-deposit/', { quote: quoteId, paymentParameters: {} })
              .then(response => {
                const body = document.getElementById('body');
                const stripe = Stripe(window.stripePublicKey);
                const elements = stripe.elements({
                  clientSecret: response.data.data.item.clientSecret
                });
                const commonStyle = {  };
                const cardNumber = elements.create('cardNumber', { disableLink: true });

                stripeApplePayHandler(elements);
                
                cardNumber.mount('#card-number-element');
                cardNumber.on('ready', () => {
                  cardNumber.focus();
                });

                function clearErrorMessage() {
                  errorMessage.textContent = '';
                  errorMessage.style.display = 'none';
                }

                const cardExpiry = elements.create('cardExpiry', commonStyle);
                cardExpiry.mount('#card-expiry-element');

                const cardCvc = elements.create('cardCvc', commonStyle);
                cardCvc.mount('#card-cvc-element');

                cardNumber.on('change', clearErrorMessage);
                cardExpiry.on('change', clearErrorMessage);
                cardCvc.on('change', clearErrorMessage);

                layout.classList.add('layout--showed');
                body.classList.add('blocked');
                
                window.setTimeout(() => {
                  payDepositBtn.classList.remove('disabled');
                  getQuoteBtn.classList.remove('disabled');
                }, 3000);
    
                // 3. Обробник сабміту
                const form = document.getElementById('payment-form');
                form.addEventListener('submit', async (event) => {
                  event.preventDefault();
                  const clientSecret = response.data.data.item.clientSecret;
                  const { paymentIntent, error } = await stripe.confirmCardPayment(clientSecret, {
                    payment_method: {
                      card: cardNumber,
                    },
                  });

                  if (error) {
                    errorMessage.textContent = error.message;
                    errorMessage.style.display = 'block';
                    // console.error(error);
                  } else if (paymentIntent.status === 'succeeded') {
                    hidePaymentModal();
                    const title = 'Thank you!';
                    const description = 'Our manager will contact <br>you very soon!';
                    popupShow(title, description);
                    cleanFormInputs(quoteForm);

                  }
                });
              });
            };
          });
        });

    closeBtn.addEventListener('click', () => {
      hidePaymentModal();
    });

    window.addEventListener('click', e => {
      if (e.target === layout) {
        hidePaymentModal();
      }
    });
    function hidePaymentModal(){
      modal.style.display = 'none';
      layout.classList.remove('layout--showed');
      body.classList.remove('blocked');
    }
  }
}

function stripeApplePayHandler(elements) {
  const expressCheckoutDiv = document.getElementById('express-checkout-element');
  expressCheckoutDiv.style.visibility = 'hidden';

  const expressCheckoutElement = elements.create("expressCheckout", {
    emailRequired: true
  });
  expressCheckoutElement.mount("#express-checkout-element");
  expressCheckoutElement.on('ready', ({availablePaymentMethods}) => {
    console.log('availablePaymentMethods', availablePaymentMethods);
    if (!availablePaymentMethods || availablePaymentMethods.length === 0) {
      // No buttons will show
    } else {
      // Optional: Animate in the Element
      expressCheckoutDiv.style.visibility = 'initial';
    }
  });
};
